<template>
  <svg width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M7.997 2C11.277 2 14 4.717 14 7.997 14 11.283 11.283 14 8.003 14S2 11.283 2 7.997C2 4.717 4.717 2 7.997 2zM7.99 3.125A4.852 4.852 0 0 0 3.125 8a4.853 4.853 0 0 0 4.872 4.875A4.855 4.855 0 0 0 12.875 8a4.871 4.871 0 0 0-4.884-4.875zM8 9.362a.66.66 0 0 1 .667.652.66.66 0 0 1-.667.653.66.66 0 0 1-.667-.653A.66.66 0 0 1 8 9.362zm0-4.029c.298 0 .544.217.583.498l.005.078V8.21A.582.582 0 0 1 8 8.787a.584.584 0 0 1-.583-.498l-.005-.078V5.909c0-.318.263-.576.588-.576z"
      fill="#737380"
      fill-rule="evenodd"
    />
  </svg>
</template>
